const Americaon2022_3=[
    {
        "Name": "chr1",
        "Length": 208936223
    },
    {
        "Name": "chr2",
        "Length": 107065966
    },
    {
        "Name": "chr3",
        "Length": 108410162
    },
    {
        "Name": "chr4",
        "Length": 88792041
    },
    {
        "Name": "chr5",
        "Length": 84808353
    },
    {
        "Name": "chr6",
        "Length": 66562909
    },
    {
        "Name": "chr7",
        "Length": 57886635
    },
    {
        "Name": "chr8",
        "Length": 55458987
    },
    {
        "Name": "unanchored",
        "Length": 4570438
    }
]
let Americaon2022_3Colums=[]
Object.keys(Americaon2022_3[0]).map(key=>{
    Americaon2022_3Colums.push({
        title:key,
        key:key,
        align:"center",
        dataIndex:key
    })
})
export {Americaon2022_3,Americaon2022_3Colums}